/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import Checker from "vux/src/components/checker/checker.vue"; // this line is trasformed by vux-loader
import CheckerItem from "vux/src/components/checker/checker-item.vue"; // this line is trasformed by vux-loader
var oneDay = 24 * 60 * 60 * 1000;
export default {
  components: {
    Datetime: Datetime,
    Checker: Checker,
    CheckerItem: CheckerItem
  },
  props: {
    value: {
      type: [Array]
    },
    title: {
      type: [String]
    },
    format: {
      type: [String],
      default: 'YYYY-MM-DD HH:mm'
    },
    middle: {
      type: [String],
      default: i18n.tc("509")
    },
    placeholder: {
      type: Array,
      default: function _default() {
        return [i18n.tc("510"), i18n.tc("510")];
      }
    },
    isShowQuick: {
      type: Boolean,
      default: false
    },
    quickList: {
      type: Array,
      default: function _default() {
        return ['today', 'yesterday', 'thisWeek', 'thisMonth'];
        // return [
        //   'today',
        //   'yesterday',
        //   'tomorrow',
        //   'afterThreeDay',
        //   'afterSevenDay',
        //   'beforeThreeDay',
        //   'beforeSevenDay',
        //   'thisWeek',
        //   'lastWeek',
        //   'nextWeek',
        //   'thisMonth',
        //   'lastMonth',
        //   'nextMonth'
        // ]
      }
    },
    defaultSelect: {
      type: [String, Number]
    },
    showBorder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      startDate: '',
      endDate: '',
      isSelectTag: false,
      allQuickList: [{
        name: i18n.tc("511"),
        value: 'today'
      }, {
        name: i18n.tc("512"),
        value: 'yesterday'
      }, {
        name: i18n.tc("513"),
        value: 'tomorrow'
      }, {
        name: i18n.tc("514"),
        value: 'afterThreeDay'
      }, {
        name: i18n.tc("515"),
        value: 'afterSevenDay'
      }, {
        name: i18n.tc("516"),
        value: 'beforeThreeDay'
      }, {
        name: i18n.tc("517"),
        value: 'beforeSevenDay'
      }, {
        name: i18n.tc("518"),
        value: 'beforeThirtyDay'
      }, {
        name: i18n.tc("519"),
        value: 'thisWeek'
      }, {
        name: i18n.tc("520"),
        value: 'lastWeek'
      }, {
        name: i18n.tc("521"),
        value: 'nextWeek'
      }, {
        name: i18n.tc("522"),
        value: 'thisMonth'
      }, {
        name: i18n.tc("523"),
        value: 'lastMonth'
      }, {
        name: i18n.tc("524"),
        value: 'nextMonth'
      }],
      radio: '',
      // tag选中值
      tagSync: false
    };
  },
  watch: {
    value: function value(val) {
      if (!this.defaultSelect) {
        this.synchrodata();
      }
    },
    defaultSelect: function defaultSelect(val) {
      var _this = this;
      if (val) {
        this.tagSync = true;
        this.radio = this.defaultSelect;
        this.selectTag.apply(this, [this.defaultSelect].concat(_toConsumableArray(this.allQuickList.filter(function (item) {
          return item.value === _this.radio;
        }))));
      }
    },
    dateRange: function dateRange(val) {
      var _this2 = this;
      if (this.radio && !this.isSelectTag) {
        this.$emit('on-select', {}, [this.startDate, this.endDate]);
        this.radio = '';
      }
      this.$emit('on-change', this.dateRange);
      // 操作结束关闭tag切换状态
      setTimeout(function () {
        _this2.isSelectTag = false;
      }, 100);
    }
  },
  computed: {
    quickOperationList: function quickOperationList() {
      var _this3 = this;
      var quickList = [];
      this.quickList.forEach(function (item) {
        quickList = [].concat(_toConsumableArray(quickList), _toConsumableArray(_this3.allQuickList.filter(function (item2) {
          return item2.value === item;
        })));
      });
      return quickList;
    },
    dateRange: function dateRange() {
      // console.log(this.startDate, this.endDate)
      return [this.startDate, this.endDate];
    }
  },
  methods: {
    // 同步数据
    synchrodata: function synchrodata() {
      if (this.value) {
        if (this.value.length !== 2) {
          console.warn('The length of the value must be two');
          return false;
        }
        if (this.value.length === 2) {
          this.startDate = this.value[0] ? new Date(this.formatDate(this.value[0])).Format(this.format) : '';
          this.endDate = this.value[1] ? new Date(this.formatDate(this.value[1])).Format(this.format) : '';
        }
      }
    },
    getTagDate: function getTagDate(name) {
      if (name === 'today') {
        // 今天
        ;
        var _this$getDayStartAndE = this.getDayStartAndEnd();
        var _this$getDayStartAndE2 = _slicedToArray(_this$getDayStartAndE, 2);
        this.startDate = _this$getDayStartAndE2[0];
        this.endDate = _this$getDayStartAndE2[1];
      } else if (name === 'tomorrow') {
        // 明天
        ;
        var _this$getDayStartAndE3 = this.getDayStartAndEnd(1);
        var _this$getDayStartAndE4 = _slicedToArray(_this$getDayStartAndE3, 2);
        this.startDate = _this$getDayStartAndE4[0];
        this.endDate = _this$getDayStartAndE4[1];
      } else if (name === 'yesterday') {
        // 昨天
        ;
        var _this$getDayStartAndE5 = this.getDayStartAndEnd(-1);
        var _this$getDayStartAndE6 = _slicedToArray(_this$getDayStartAndE5, 2);
        this.startDate = _this$getDayStartAndE6[0];
        this.endDate = _this$getDayStartAndE6[1];
      } else if (name === 'afterThreeDay') {
        // 未来三天
        ;
        var _this$getIntervalDayS = this.getIntervalDayStartAndEnd(3);
        var _this$getIntervalDayS2 = _slicedToArray(_this$getIntervalDayS, 2);
        this.startDate = _this$getIntervalDayS2[0];
        this.endDate = _this$getIntervalDayS2[1];
      } else if (name === 'afterSevenDay') {
        // 未来七天
        ;
        var _this$getIntervalDayS3 = this.getIntervalDayStartAndEnd(7);
        var _this$getIntervalDayS4 = _slicedToArray(_this$getIntervalDayS3, 2);
        this.startDate = _this$getIntervalDayS4[0];
        this.endDate = _this$getIntervalDayS4[1];
      } else if (name === 'beforeThreeDay') {
        // 过去三天
        ;
        var _this$getIntervalDayS5 = this.getIntervalDayStartAndEnd(-3);
        var _this$getIntervalDayS6 = _slicedToArray(_this$getIntervalDayS5, 2);
        this.startDate = _this$getIntervalDayS6[0];
        this.endDate = _this$getIntervalDayS6[1];
      } else if (name === 'beforeSevenDay') {
        // 过去七天
        ;
        var _this$getIntervalDayS7 = this.getIntervalDayStartAndEnd(-7);
        var _this$getIntervalDayS8 = _slicedToArray(_this$getIntervalDayS7, 2);
        this.startDate = _this$getIntervalDayS8[0];
        this.endDate = _this$getIntervalDayS8[1];
      } else if (name === 'beforeThirtyDay') {
        // 过去30天
        ;
        var _this$getIntervalDayS9 = this.getIntervalDayStartAndEnd(-30);
        var _this$getIntervalDayS10 = _slicedToArray(_this$getIntervalDayS9, 2);
        this.startDate = _this$getIntervalDayS10[0];
        this.endDate = _this$getIntervalDayS10[1];
      } else if (name === 'thisWeek') {
        // 本周
        ;
        var _this$getWeekStartAnd = this.getWeekStartAndEnd();
        var _this$getWeekStartAnd2 = _slicedToArray(_this$getWeekStartAnd, 2);
        this.startDate = _this$getWeekStartAnd2[0];
        this.endDate = _this$getWeekStartAnd2[1];
      } else if (name === 'nextWeek') {
        // 下一周
        ;
        var _this$getWeekStartAnd3 = this.getWeekStartAndEnd(1);
        var _this$getWeekStartAnd4 = _slicedToArray(_this$getWeekStartAnd3, 2);
        this.startDate = _this$getWeekStartAnd4[0];
        this.endDate = _this$getWeekStartAnd4[1];
      } else if (name === 'lastWeek') {
        // 上一周
        ;
        var _this$getWeekStartAnd5 = this.getWeekStartAndEnd(-1);
        var _this$getWeekStartAnd6 = _slicedToArray(_this$getWeekStartAnd5, 2);
        this.startDate = _this$getWeekStartAnd6[0];
        this.endDate = _this$getWeekStartAnd6[1];
      } else if (name === 'thisMonth') {
        // 本月
        ;
        var _this$getMonthStartAn = this.getMonthStartAndEnd();
        var _this$getMonthStartAn2 = _slicedToArray(_this$getMonthStartAn, 2);
        this.startDate = _this$getMonthStartAn2[0];
        this.endDate = _this$getMonthStartAn2[1];
      } else if (name === 'nextMonth') {
        // 下一个月
        ;
        var _this$getMonthStartAn3 = this.getMonthStartAndEnd(1);
        var _this$getMonthStartAn4 = _slicedToArray(_this$getMonthStartAn3, 2);
        this.startDate = _this$getMonthStartAn4[0];
        this.endDate = _this$getMonthStartAn4[1];
      } else if (name === 'lastMonth') {
        // 上一个月
        ;
        var _this$getMonthStartAn5 = this.getMonthStartAndEnd(-1);
        var _this$getMonthStartAn6 = _slicedToArray(_this$getMonthStartAn5, 2);
        this.startDate = _this$getMonthStartAn6[0];
        this.endDate = _this$getMonthStartAn6[1];
      }
    },
    selectTag: function selectTag(name, data) {
      if (!this.defaultSelect) {
        // 未选中状态点击
        if (!this.radio || this.radio !== name) {
          this.isSelectTag = true; // tag选中状态
          this.getTagDate(name);
          this.$emit('on-select', data, [this.startDate, this.endDate]);
        } else {
          this.$emit('on-select', {}, [this.startDate, this.endDate]);
          // 选中状态点击 清空
          this.startDate = '';
          this.endDate = '';
        }
      } else {
        // 初始化tag选中同步
        if (this.tagSync) {
          this.isSelectTag = true; // tag选中状态
          this.getTagDate(name);
          this.$emit('on-select', data);
          this.tagSync = false;
        } else {
          if (!this.radio || this.radio !== name) {
            this.isSelectTag = true; // tag选中状态
            this.getTagDate(name);
            this.$emit('on-select', data);
          } else {
            this.$emit('on-select', {});
            // 选中状态点击 清空
            this.startDate = '';
            this.endDate = '';
            console.log(this.startDate, this.endDate);
          }
        }
      }
    },
    // 获取当前时刻起间隔count天日期 count：3未来三天、-3过去三天
    getIntervalDayStartAndEnd: function getIntervalDayStartAndEnd() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startStop = [];
      var nowDate = new Date();
      var start = nowDate.Format(this.format);
      var end = new Date(nowDate.setTime(nowDate.getTime() + oneDay * count)).Format(this.format);
      startStop.push(start);
      startStop.push(end);
      return count >= 0 ? startStop : startStop.reverse();
    },
    // 获取今天日期 monthCount：0今天、-1昨天、1明天
    getDayStartAndEnd: function getDayStartAndEnd() {
      var dayCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startStop = [];
      var start = new Date(new Date().setHours(0, 0, 0) + oneDay * dayCount).Format(this.format);
      var end = new Date(new Date().setHours(23, 59, 59) + oneDay * dayCount).Format(this.format);
      startStop.push(start);
      startStop.push(end);
      return startStop;
    },
    // 获取本月日期 monthCount：0当前月、-1上一个月、1下一个月
    getMonthStartAndEnd: function getMonthStartAndEnd() {
      var monthCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startStop = [];
      var currentDate = new Date();
      var month = currentDate.getMonth() + monthCount;
      if (month < 0) {
        var n = parseInt(-month / 12);
        month += n * 12;
        currentDate.setFullYear(currentDate.getFullYear() - n);
      }
      currentDate = new Date(currentDate.setMonth(month));
      // 获得当前月份 0-11
      var currentMonth = currentDate.getMonth();
      // 获得当前年份4位年
      var currentYear = currentDate.getFullYear();
      // 获得上一个月的第一天
      var currentMonthFirstDay = new Date(currentYear, currentMonth, 1).Format(this.format);
      // 获得上一月的最后一天
      var currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0).setHours(23, 59, 59);
      currentMonthLastDay = new Date(currentMonthLastDay).Format(this.format);
      startStop.push(currentMonthFirstDay);
      startStop.push(currentMonthLastDay);
      return startStop;
    },
    // 获取本月日期 weekCount：0当本周、-1上一周、1下一周
    getWeekStartAndEnd: function getWeekStartAndEnd() {
      var weekCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startStop = [];
      var now = new Date();
      var nowTime = now.getTime();
      var day = now.getDay(); // 本周的第几天
      var MondayTime = nowTime - (day - 1) * oneDay + weekCount * 7 * oneDay;
      var SundayTime = nowTime + (7 - day) * oneDay + weekCount * 7 * oneDay;
      var start = new Date(MondayTime).setHours(0, 0, 0);
      var end = new Date(SundayTime).setHours(23, 59, 59);
      start = new Date(start).Format(this.format);
      end = new Date(end).Format(this.format);
      startStop.push(start);
      startStop.push(end);
      return startStop;
    },
    // 2018-1-1 00:00 转换为 Wed Jul 25 2018 14:11:22 GMT+0800 (中国标准时间)
    formatDate: function formatDate(data) {
      var time = data.split(' ');
      var sdate = time[0].split('-');
      var date = new Date(sdate[0], sdate[1] - 1, sdate[2]);
      if (time[1]) {
        var stime = time[1].split(':');
        date.setHours.apply(date, _toConsumableArray(stime));
      }
      return date;
    },
    onChange: function onChange(e) {
      // 不是切换状态时改变日期，清空选中tag状态
      // console.log(this.radio)
      // console.log(this.isSelectTag)
      // if (this.radio && !this.isSelectTag) this.radio = ''
      // this.$emit('on-change', [this.startDate, this.endDate])
      // // 操作结束关闭tag切换状态
      // setTimeout(() => {
      //   this.isSelectTag = false
      // }, 100)
    }
  },
  created: function created() {
    var _this4 = this;
    if (this.defaultSelect) {
      this.tagSync = true;
      this.radio = this.defaultSelect;
      this.selectTag.apply(this, [this.defaultSelect].concat(_toConsumableArray(this.allQuickList.filter(function (item) {
        return item.value === _this4.radio;
      }))));
    } else {
      this.synchrodata();
    }
  }
};